import React, { useState } from 'react';
import Logo from "../../assets/images/bni_logo.jpeg";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { postAxios } from '../../service/axios_service';
import { loginEndPoint } from '../../service/api_endpoints';
import { useNavigate } from 'react-router-dom';  // Import navigate function

export default function Login() {
  const navigate = useNavigate(); // Initialize navigate

    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const formik = useFormik({
      initialValues: {
          username: '',
          password: ''
      },
      validationSchema: Yup.object({
          username: Yup.string().required('Required'),
          password: Yup.string().required('Required'),
      }),
      onSubmit: async (values) => {
        try {
            let response = await postAxios({
                url: loginEndPoint,
                body: { username: values.username, password: values.password },
                requireAuth: false  
            });
    
            console.log("📢 Full API Response:", response);
    
            // ✅ Fix: Access the token inside the `data` object
            if (response != null) {
              localStorage.setItem('is_authenticated', true)
              localStorage.setItem('login', JSON.stringify(response.data))
              window.location.reload()
            }
      
        } catch (error) {
            console.error("🚨 Error during login:", error);
            setErrorMessage('Login failed! Please try again.');
        }
    }
    
    
  });
    
    
    

  


    return (
        <div className='w-screen h-screen bg-light-gray flex items-center justify-center'>
            <div className='bg-white w-[300px] sm:w-[450px] p-[20px] rounded-[10px]'>
                <div className='w-[75px] h-[75px] mx-auto'>
                    <img src={Logo} width={"100%"} alt="Logo" />
                </div>
                <p className='font-semibold text-xl text-center'>Sign in to account</p>
                <p className='text-sm sm:text-md text-center text-light-gray'>Enter your email & password to login</p>

                <form className='mt-[30px]' onSubmit={formik.handleSubmit}>
                    <div className='my-[10px]'>
                        <p>Username</p>
                        <input
                            type='text'
                            name='username'
                            id='username'
                            className='text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px]'
                            onChange={formik.handleChange}
                            value={formik.values.username}
                        />
                        {formik.errors.username && <p className='text-red-500 text-xs'>{formik.errors.username}</p>}
                    </div>
                    <div className='my-[10px]'>
                        <p>Password</p>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name='password'
                            id='password'
                            className='text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px]'
                            onChange={formik.handleChange}
                            value={formik.values.password}
                        />
                        {formik.errors.password && <p className='text-red-500 text-xs'>{formik.errors.password}</p>}
                    </div>

                    {errorMessage && <p className='text-red-500 text-xs'>{errorMessage}</p>}

                    <div className='flex justify-end items-center gap-3 my-[35px]'>
                        <button className='text-primary text-sm underline'>Forgot Password</button>
                    </div>

                    <button type='submit' className='w-full bg-primary px-[15px] py-[10px] text-white rounded'>Sign In</button>
                </form>
            </div>
        </div>
    );
}
